
import { Component, Prop, Vue, State } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { File } from '@/types/contentContract';

@Component({})
export default class ResponsiveImage extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.page?.status)
  pageStatus!: number;

  @Prop({ type: Object as PropType<File>, required: true })
  file!: File;

  @Prop({ type: Boolean, default: false })
  equalMediaHeight!: boolean;

  @Prop({ type: Boolean, default: false })
  equalMediaWidth!: boolean;

  @Prop({ type: String, default: 'presentation' })
  role!: string;

  @Prop({ type: Number, default: null })
  aspectRatio!: number | null;

  loadEventFired: boolean = false;
  lazyLoaded: boolean = false;
  lazyInitialized: boolean = false;
  isImageCarousel: boolean = false;

  get isTransparentImage(): boolean {
    return (
      this.file.publicUrl.endsWith('.png') ||
      this.file.publicUrl.endsWith('.svg') ||
      this.file.publicUrl.endsWith('.gif')
    );
  }

  get isSvg(): boolean {
    return this.file.publicUrl.endsWith('.svg');
  }

  get activeAspectRatio(): number {
    if (this.aspectRatio) {
      return this.aspectRatio;
    }
    return (
      this.file.properties.dimensions.height /
      this.file.properties.dimensions.width
    );
  }

  get style(): object {
    const paddingTop = `${this.activeAspectRatio.toFixed(5) * 100}%`;

    return {
      paddingTop
    };
  }

  get hasAccess(): boolean {
    return this.pageStatus !== 403;
  }

  handleLoaded(): void {
    this.loadEventFired = true;
    this.handleLoadedAndLazyInitialized();
  }

  onIntersect(): void {
    this.lazyInitialized = true;
    this.handleLoadedAndLazyInitialized();
  }

  handleLoadedAndLazyInitialized(): void {
    if (this.lazyInitialized && this.loadEventFired) {
      this.lazyLoaded = true;
    }
  }

  mounted() {
    const isCarousel =
      this.$el.parentElement.parentElement.parentElement.parentElement.parentElement.classList.contains(
        'swiper-slide'
      );
    if (isCarousel) {
      this.isImageCarousel = true;
    }
  }
}
